module.exports = __webpack_public_path__ + "static/media/frog_mobile.8ea28dbc.png";